import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { PortalWaliDashboard } from '../components/portalwalisantri/PortalWaliDashboard';

const PortalWaliKaldikUmum = React.lazy(() => import('../components/portalwalisantri/PortalWaliKaldikUmum').then(module => ({ default: module.PortalWaliKaldikUmum })));
const PortalWaliTahfidz = React.lazy(() => import('../components/portalwalisantri/tahfidz/PortalWaliTahfidz').then(module => ({ default: module.PortalWaliTahfidz })));
const PortalWaliPerizinan = React.lazy(() => import('../components/portalwalisantri/PortalWaliPerizinan').then(module => ({ default: module.PortalWaliPerizinan })));
const PortalWaliAkademik = React.lazy(() => import('../components/portalwalisantri/PortalWaliAkademik').then(module => ({ default: module.PortalWaliAkademik })));
const PortalWaliAkademikRekap = React.lazy(() => import('../components/portalwalisantri/PortalWaliAkademikRekap').then(module => ({ default: module.PortalWaliAkademikRekap })));
const PortalWaliPrestasi = React.lazy(() => import('../components/portalwalisantri/PortalWaliPrestasi').then(module => ({ default: module.PortalWaliPrestasi })));

export const PortalWaliSantriRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute><PortalWaliDashboard /></ProtectedRoute>} />
      <Route path="kaldik-umum" element={<ProtectedRoute><PortalWaliKaldikUmum /></ProtectedRoute>} />
      <Route path="tahfidz" element={<ProtectedRoute><PortalWaliTahfidz /></ProtectedRoute>} />
      <Route path="perizinan" element={<ProtectedRoute><PortalWaliPerizinan /></ProtectedRoute>} />
      <Route path="akademik" element={<ProtectedRoute><PortalWaliAkademik /></ProtectedRoute>} />
      <Route path="akademik/rekap" element={<ProtectedRoute><PortalWaliAkademikRekap /></ProtectedRoute>} />
      <Route path="prestasi" element={<ProtectedRoute><PortalWaliPrestasi /></ProtectedRoute>} />
    </Routes>
  );
};
